interface AiAssistantState {
  isOpen: boolean;
  // null = not yet checked, true/false = backend's answer.
  // The real gate is the backend allowlist; this flag is UX-only.
  allowed: boolean | null;
}

export default {
  namespaced: true,
  state: (): AiAssistantState => ({ isOpen: false, allowed: null }),
  mutations: {
    toggle(state: AiAssistantState) {
      state.isOpen = !state.isOpen;
    },
    open(state: AiAssistantState) {
      state.isOpen = true;
    },
    close(state: AiAssistantState) {
      state.isOpen = false;
    },
    setAllowed(state: AiAssistantState, allowed: boolean | null) {
      state.allowed = allowed;
      if (!allowed) state.isOpen = false;
    },
  },
  actions: {
    async fetchAccess({ commit, rootState }: any) {
      const baseUrl = import.meta.env.VITE_KHABEER_AI_URL;
      const token = rootState.user?.accessToken;
      if (!baseUrl || !token) {
        commit("setAllowed", false);
        return;
      }
      try {
        const res = await fetch(`${baseUrl}/api/access`, {
          method: "GET",
          headers: { "X-OFFICER-TOKEN": token },
        });
        if (!res.ok) {
          commit("setAllowed", false);
          return;
        }
        const data = (await res.json()) as { allowed?: boolean };
        commit("setAllowed", data.allowed === true);
      } catch {
        // Network failure / backend down → fail closed so the bubble stays hidden.
        commit("setAllowed", false);
      }
    },
  },
};
